/**
* Small, dependency-free number/time formatters shared by the external API
* analytics page and the clients list (VD-725).
*/

export const formatNumber = (value) => {
    let n = Number(value);

    if (value === null || value === undefined || isNaN(n)) {
        return '0';
    }

    return n.toLocaleString();
};

export const formatPercent = (part, total, digits = 1) => {
    let p = Number(part);
    let t = Number(total);

    if (!t || isNaN(p) || isNaN(t)) {
        return '0%';
    }

    return `${((p / t) * 100).toFixed(digits)}%`;
};

export const formatMs = (value) => {
    let n = Number(value);

    if (value === null || value === undefined || isNaN(n)) {
        return '-';
    }

    if (n < 1000) {
        return `${Math.round(n)} ms`;
    }

    return `${(n / 1000).toFixed(2)} s`;
};

/**
* Bytes with a unit that fits the size: `232 B`, `1.2 KB`, `12.4 MB`, `1.27 GB`.
* Base 1024, the same as the backend's `estimatedGb`. `null` is unknown, shown as "—".
*/
export const formatBytes = (value) => {
    let n = Number(value);

    if (value === null || value === undefined || isNaN(n)) {
        return '—';
    }

    let units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let i = 0;

    while (n >= 1024 && i < units.length - 1) {
        n /= 1024;
        i += 1;
    }

    if (i === 0) return `${Math.round(n)} B`;
    if (i >= 3) return `${n.toFixed(2)} ${units[i]}`;
    return `${n < 100 ? n.toFixed(1) : Math.round(n)} ${units[i]}`;
};
